"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchUpdateBaseGlobalInstructionDiscriminator = exports.BatchUpdateBaseGlobalStruct = void 0;
exports.createBatchUpdateBaseGlobalInstruction = createBatchUpdateBaseGlobalInstruction;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const WrapperBatchUpdateParams_1 = require("../types/WrapperBatchUpdateParams");
/**
 * @category Instructions
 * @category BatchUpdateBaseGlobal
 * @category generated
 */
exports.BatchUpdateBaseGlobalStruct = new beet.FixableBeetArgsStruct([
    ['instructionDiscriminator', beet.u8],
    ['params', WrapperBatchUpdateParams_1.wrapperBatchUpdateParamsBeet],
], 'BatchUpdateBaseGlobalInstructionArgs');
exports.batchUpdateBaseGlobalInstructionDiscriminator = 5;
/**
 * Creates a _BatchUpdateBaseGlobal_ instruction.
 *
 * @param accounts that will be accessed while the instruction is processed
 * @param args to provide as instruction data to the program
 *
 * @category Instructions
 * @category BatchUpdateBaseGlobal
 * @category generated
 */
function createBatchUpdateBaseGlobalInstruction(accounts, args, programId = new web3.PublicKey('wMNFSTkir3HgyZTsB7uqu3i7FA73grFCptPXgrZjksL')) {
    const [data] = exports.BatchUpdateBaseGlobalStruct.serialize({
        instructionDiscriminator: exports.batchUpdateBaseGlobalInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: accounts.wrapperState,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.manifestProgram,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.owner,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: accounts.market,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.systemProgram ?? web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.baseMint,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.baseGlobal,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.baseGlobalVault,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.baseMarketVault,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.baseTokenProgram,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId,
        keys,
        data,
    });
    return ix;
}
